import React, { useState, useEffect, useRef } from "react";
import "./notification.css";
import useHttp from "../hooks/use-http";
import Select from "react-select";
import { toast } from "react-toastify";

const Notification = (props) => {
  const { useCase } = props;
  const frmRef = useRef({});
  var d = new Date();
  var date = d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();

  var time = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();

  const [currentTime, setCurrentTime] = useState("");
  const [data, setData] = useState("");
  const [selectionUser, setSelectionUser] = useState([]);
  const [selectedUser, setSelectedUser] = useState();
  const [isUserDetailEmpty, setIsUserDetailEmpty] = useState(true);

  const [userDetail, setUserDetail] = useState();
  const [subject, setSubject] = useState();
  const [messageBody, setMessageBody] = useState();

  useEffect(() => {
    const now = new Date();
    const timeString = now.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
    setCurrentTime(timeString);
  }, []);

  const { sendRequest: getUser } = useHttp();

  useEffect(() => {
    getUser(
      {
        url: `/api/employeeByUsecase/?useCase=${useCase}&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          //console.log(res.output);
          //   setData(res.output);
          setSelectionUser(
            res.output.map((x) => ({
              value: x.userId,
              label: x.employeeName,
            }))
          );
        }
      }
    );
  }, [getUser]);

  useEffect(() => {
    const convertedData =
      selectedUser &&
      selectedUser.map((item) => {
        return { userId: item.value };
      });

    // //console.log(convertedData);
    setUserDetail(convertedData);
    setIsUserDetailEmpty(!convertedData || convertedData.length === 0);
  }, [selectedUser]);

  const handleUserChange = (option) => {
    //console.log(option);
    setSelectedUser(option);
  };

  const { sendRequest: sendNotification } = useHttp();

  const handleNotification = (e) => {
    e.preventDefault();

    if (isUserDetailEmpty) {
      toast.error("Please select users");
      return;
    }
    const data = {
      messageSubject: subject,
      messageBody: messageBody,
      UserDetail: userDetail,
      broadcastDate: date,
      broadcastTime: time,
      remark: "remark",
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: parseInt(localStorage.getItem("orgId")),
    };

    //console.log(data);

    sendNotification(
      {
        url: "/api/send_notification/",
        method: "POST",
        body: data,
      },
      (data) => {
        if (data.success) {
          toast.success(data.message);
          setMessageBody("");
          setSelectedUser("");
          setSubject("");
        }

        if (data.error) {
          toast.error(data.error);
        }
      }
    );
  };

  return (
    <>
      <form onSubmit={handleNotification} className="form-content">
        <div className="container-fluid">
          {/* SELECT2 EXAMPLE */}

          {/* /.card-header */}
          <div className="card-body">
            <div className="row">
              <div className="col-md-2">
                <div className="form-group">
                  <label>Date</label>

                  <input
                    type={"text"}
                    readOnly
                    id={"Date"}
                    value={new Date().toLocaleDateString()}
                    ref={(el) => (frmRef.current["Date"] = el)}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>Time</label>

                  <input
                    type={"text"}
                    readOnly
                    id={"time"}
                    value={currentTime}
                    ref={(el) => (frmRef.current["time"] = el)}
                    className="form-control"
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label>Select User</label>
                  <Select
                    isMulti
                    options={selectionUser}
                    value={selectedUser}
                    onChange={(option) => {
                      handleUserChange(option);
                    }}
                    className="basic-multi-select"
                    isRequired={true}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <label>Subject</label>
                <input
                  type="text"
                  name="subject"
                  required
                  value={subject}
                  className="form-control"
                  onChange={(e) => setSubject(e.target.value)}
                />
              </div>

              <div className="col-md-4"></div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <label>Message</label>
                <textarea
                  name="message"
                  required
                  value={messageBody}
                  className="form-control"
                  placeholder="Enter your message"
                  maxLength={500}
                  onChange={(e) => {
                    setMessageBody(e.target.value);

                    // Auto Expand
                    e.target.style.height = "auto";
                    e.target.style.height = `${e.target.scrollHeight}px`;
                  }}
                  style={{
                    minHeight: "60px",      
                    maxHeight: "200px",     
                    overflowY: "auto",      
                    resize: "none"          
                  }}
                ></textarea>


                {/* 🔹 Character Count */}
                <small style={{ color: "gray" }}>
                  {messageBody?.length || 0}/500 characters
                </small>
              </div>

              <div className="col-md-4"></div>
            </div>



            <div className="row">
              <div className="col-md-4"></div>
              <div className="col-md-1"> </div>
              <div className="col-md-1">
                {" "}
                <button className="btn  btn-primary mx-2 my-2" type="submit">
                  Submit
                </button>
              </div>
              <div className="col-md-1">
                {/* <button className="btn  btn-primary mx-2 my-2" type="submit">
                Cancel
              </button> */}
              </div>
              <div className="col-md-1"> </div>
              <div className="col-md-4"></div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default Notification;
